import React from "react";
import { useState } from "react";
import useAuth from "../../hooks/useAuth";
import { useCreateMeetingMutation } from "../EditDataSources/EditDataSourceSlice";
import { useEffect } from "react";

export default function AddMeeting({ setTabValue }) {
  const { username } = useAuth();
  const getISTDateTimeLocal = () => {
    const now = new Date();
    const istOffset = 5.5 * 60; // IST offset in minutes
    const localOffset = now.getTimezoneOffset(); // Local offset in minutes
    const istTime = new Date(
      now.getTime() + (istOffset + localOffset) * 60 * 1000
    );

    const pad = (num) => String(num).padStart(2, "0");

    const year = istTime.getFullYear();
    const month = pad(istTime.getMonth() + 1);
    const date = pad(istTime.getDate());
    const hours = pad(istTime.getHours());
    const minutes = pad(istTime.getMinutes());

    return `${year}-${month}-${date}T${hours}:${minutes}`;
  };
  const getISTDateTimeParts = () => {
    const now = new Date();
    const istOffset = 5.5 * 60; // IST in minutes
    const localOffset = now.getTimezoneOffset(); // Local timezone offset in minutes
    const istTime = new Date(now.getTime() + (istOffset + localOffset) * 60000);

    const pad = (num) => String(num).padStart(2, "0");

    const year = istTime.getFullYear();
    const month = pad(istTime.getMonth() + 1);
    const date = pad(istTime.getDate());
    const hours = pad(istTime.getHours());
    const minutes = pad(istTime.getMinutes());
    const seconds = pad(istTime.getSeconds());

    return {
      dateOfCheckInDate: `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`,
      checkInTime: `${hours}:${minutes}:${seconds}`,
    };
  };

  const { dateOfCheckInDate, checkInTime } = getISTDateTimeParts();
  const [form, setForm] = useState({
    meetingCategory: "",
    username: username || "",
    whomToVisit: "",
    dateOfCheckInDate: dateOfCheckInDate,
    checkInTime: checkInTime,
    accountName: "",
    subject: "",
    latitude: "",
    longitude: "",
  });
  console.log(form.checkInTime);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };
  const [createMeeting, { data, isError, error, isLoading, isSuccess }] =
    useCreateMeetingMutation();
  if (data) {
    console.log(data);
  }
  useEffect(() => {
    if (data && data["message"]) {
      const timer = setTimeout(() => {
        setTabValue("all");
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [data]);

  useEffect(() => {
    const getLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            console.log(latitude);
            console.log(longitude);

            setForm((prev) => ({
              ...prev,
              latitude: Number(latitude.toFixed(6)),
              longitude: Number(longitude.toFixed(6)),
            }));
          },
          (error) => {
            console.error("Error fetching location:", error);
            alert("Unable to retrieve your location.");
          }
        );
      } else {
        alert("Geolocation is not supported by this browser.");
      }
    };
    getLocation();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const {
      meetingCategory,
      username,
      whomToVisit,
      checkInTime,
      subject,
      dateOfCheckInDate,
      accountName,
      latitude,
      longitude,
    } = form;
    // console.log("Form Submitted:", form);
    const object = {
      databaseID: "67f8d94fd87ed27dc5b2b305",
      data: [
        {
          Meeting_category: meetingCategory,
          Owner_Name: username,
          Whom_To_Visit: whomToVisit,
          check_in_time: checkInTime,
          Day_of_check_in_date: dateOfCheckInDate,
          Account_Name: accountName,
          Subject: subject,
          Latitude: latitude,
          Longitude: longitude,
        },
      ],
    };
    console.log(object);
    createMeeting(object);
  };
  return (
    <section className="w-full h-[94vh] flex items-center justify-center ">
      <form
        onSubmit={handleSubmit}
        className="sm:w-full md:w-[35%] h-full flex flex-col gap-4 items-center justify-center"
      >
        <div className="flex flex-col w-full items-start gap-2">
          <label htmlFor="meetingCategory" className="font-medium">
            Meeting Category
          </label>
          <select
            name="meetingCategory"
            value={form.meetingCategory}
            onChange={handleChange}
            required
            className="border rounded w-full p-[0.2rem] focus:outline-none"
          >
            <option value="">Select Category</option>
            <option value="new business">New Business</option>
            <option value="existing business">Existing Business</option>
          </select>
        </div>

        <div className="flex flex-col w-full items-start gap-2">
          <label htmlFor="username" className="font-medium">
            Username
          </label>
          <input
            type="text"
            name="username"
            value={form.username}
            readOnly
            required
            placeholder="user123"
            className="border rounded w-full p-[0.2rem] focus:outline-none"
          />
        </div>

        <div className="flex flex-col w-full items-start gap-2">
          <label htmlFor="whomToVisit" className="font-medium">
            Whom to Visit
          </label>
          <input
            type="text"
            name="whomToVisit"
            value={form.whomToVisit}
            onChange={handleChange}
            required
            placeholder="John Doe"
            className="border rounded w-full p-[0.2rem] focus:outline-none"
          />
        </div>

        <div className="flex flex-col w-full items-start gap-2">
          <label htmlFor="checkInTime" className="font-medium">
            Check-In Time
          </label>
          <input
            type="text"
            name="checkInTime"
            value={form.checkInTime}
            required
            readOnly
            className="border rounded w-full p-[0.2rem] focus:outline-none"
          />
        </div>

        <div className="flex flex-col w-full items-start gap-2">
          <label htmlFor="subject" className="font-medium">
            Subject
          </label>
          <input
            type="text"
            name="subject"
            value={form.subject}
            onChange={handleChange}
            placeholder="Meeting Subject"
            className="border rounded w-full p-[0.2rem] focus:outline-none"
          />
        </div>
        <div className="flex flex-col w-full items-start gap-2">
          <label htmlFor="subject" className="font-medium">
            Account Name
          </label>
          <input
            type="text"
            name="accountName"
            value={form.accountName}
            onChange={handleChange}
            placeholder="Harry Potter"
            className="border rounded w-full p-[0.2rem] focus:outline-none"
          />
        </div>
        <div className="w-full flex items-center justify-start gap-2">
          <div className="flex items-center w-[49%] justify-between gap-2">
            <label htmlFor="latitude" className="font-medium">
              Latitude
            </label>
            <input
              type="text"
              name="latitude"
              value={form.latitude}
              readOnly
              required
              placeholder="Enter Latitude"
              className="border rounded w-full p-[0.2rem] focus:outline-0"
            />
          </div>

          <div className="flex items-center w-[49%] justify-between gap-2">
            <label htmlFor="longitude" className="font-medium">
              Longitude
            </label>
            <input
              type="text"
              name="longitude"
              value={form.longitude}
              readOnly
              required
              placeholder="Enter Longitude"
              className="border rounded w-full p-[0.2rem] focus:outline-0"
            />
          </div>
        </div>

        <div className="flex items-center w-full justify-end gap-2">
          {isError ? (
            <span className="text-red-500 font-medium">An Error Occured</span>
          ) : null}
          {data !== undefined ? (
            <span className="text-green-500 font-medium">
              {data["message"]}
            </span>
          ) : null}
          <button
            type="submit"
            className="bg-blue-950 text-white rounded px-4 py-1"
          >
            {isLoading ? "Adding" : "Add"}
          </button>
        </div>
      </form>
    </section>
  );
}
